import React from 'react';
import Details from 'components/UIKit/Details';

export type CaseOverviewDetailsType = {
  report: Object
}

export default function CaseOverviewDetails({
  report
}: CaseOverviewDetailsType): React.Element {
  return (
    <Details>
      <table style={{ width: `100%` }}>
        <tbody>

        </tbody>
      </table>
    </Details>
  );
}
